export default {
    "v":
        "5.7.6", "fr":
        29.9700012207031, "ip":
        0, "op":
        90.0000036657751, "w":
        1920, "h":
        1920, "nm":
        "main", "ddd":
        0, "assets":
        [], "layers":
        [{
            "ddd": 0, "ind": 1, "ty": 4, "nm": "cloud", "sr": 1, "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [957, 300, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [100.154, 29.477, 0], "ix": 1, "l": 2},
                "s": {
                    "a": 1,
                    "k": [{
                        "i": {"x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 0.833]},
                        "o": {"x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167]},
                        "t": 0,
                        "s": [868.159, 868.159, 100]
                    }, {
                        "i": {"x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 0.833]},
                        "o": {"x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167]},
                        "t": 9,
                        "s": [868.159, 868.159, 100]
                    }, {
                        "i": {"x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 0.833]},
                        "o": {"x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167]},
                        "t": 12,
                        "s": [1014.159, 1014.159, 100]
                    }, {
                        "i": {"x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 0.833]},
                        "o": {"x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167]},
                        "t": 16,
                        "s": [868.159, 868.159, 100]
                    }, {
                        "i": {"x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 0.833]},
                        "o": {"x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167]},
                        "t": 70,
                        "s": [868.159, 868.159, 100]
                    }, {
                        "i": {"x": [0.833, 0.833, 0.833], "y": [0.833, 0.833, 0.833]},
                        "o": {"x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0.167]},
                        "t": 75,
                        "s": [767.159, 767.159, 100]
                    }, {"t": 80.0000032584668, "s": [868.159, 868.159, 100]}],
                    "ix": 6,
                    "l": 2
                }
            }, "ao": 0, "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[-5.142, 0], [-2.096, -7.313], [-0.657, 0], [0, -6.213], [6.209, 0], [0, 0], [0, 0], [0.46, 0], [0, 8.285], [-8.279, 0], [-1.427, -0.451]],
                            "o": [[7.982, 0], [0.626, -0.108], [6.209, 0], [0, 6.213], [0, 0], [0, 0], [-0.449, 0.041], [-8.279, 0], [0, -8.285], [1.576, 0], [3.2, -3.535]],
                            "v": [[1.249, -17.531], [18.061, -4.867], [19.986, -5.031], [31.228, 6.219], [19.986, 17.47], [1.249, 17.47], [-14.876, 17.47], [-16.239, 17.531], [-31.228, 2.53], [-16.239, -12.47], [-11.716, -11.775]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.066699996649, 0.341199987075, 0.725500009574, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [100.4, 27.915], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 1",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }], "ip": 0, "op": 90.0000036657751, "st": 0, "bm": 0
        }, {
            "ddd": 0,
            "ind": 2,
            "ty": 4,
            "nm": "card-007",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [{
                        "i": {"x": [0.833], "y": [1]},
                        "o": {"x": [0.167], "y": [0]},
                        "t": 0,
                        "s": [0]
                    }, {
                        "i": {"x": [0.393], "y": [1]},
                        "o": {"x": [0.504], "y": [0]},
                        "t": 46,
                        "s": [0]
                    }, {
                        "i": {"x": [0.833], "y": [1]},
                        "o": {"x": [0.328], "y": [0]},
                        "t": 51,
                        "s": [100]
                    }, {
                        "i": {"x": [0.367], "y": [1]},
                        "o": {"x": [0.645], "y": [0]},
                        "t": 74,
                        "s": [100]
                    }, {"t": 89.0000036250443, "s": [0]}],
                    "ix": 11
                },
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {
                    "a": 1,
                    "k": [{
                        "i": {"x": 0.682, "y": 0.682},
                        "o": {"x": 0.322, "y": 0.322},
                        "t": 0,
                        "s": [960, 960, 0],
                        "to": [0, 0, 0],
                        "ti": [0, 0, 0]
                    }, {
                        "i": {"x": 0.367, "y": 1},
                        "o": {"x": 0.645, "y": 0},
                        "t": 74,
                        "s": [960, 960, 0],
                        "to": [0, -13, 0],
                        "ti": [0, 0, 0]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.633, "y": 0},
                        "t": 89,
                        "s": [960, 882, 0],
                        "to": [0, 0, 0],
                        "ti": [0, 0, 0]
                    }, {"t": 149.000006068894, "s": [960, 960, 0]}],
                    "ix": 2,
                    "l": 2
                },
                "a": {"a": 0, "k": [100.5, 100.5, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [868.159, 868.159, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[-1.32, 0], [0, 0], [0, -1.32], [0, 0], [1.32, 0], [0, 0], [0, 1.32], [0, 0]],
                            "o": [[0, 0], [1.32, 0], [0, 0], [0, 1.32], [0, 0], [-1.32, 0], [0, 0], [0, -1.32]],
                            "v": [[-12.325, -6.276], [12.324, -6.276], [14.725, -3.876], [14.725, 3.876], [12.324, 6.276], [-12.325, 6.276], [-14.725, 3.876], [-14.725, -3.876]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.74900004069, 0.854899986117, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [100.4, 147.886], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 1",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }],
            "ip": 0,
            "op": 90.0000036657751,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 3,
            "ty": 4,
            "nm": "card-008",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [{
                        "i": {"x": [0.833], "y": [1]},
                        "o": {"x": [0.167], "y": [0]},
                        "t": 0,
                        "s": [0]
                    }, {
                        "i": {"x": [0.393], "y": [1]},
                        "o": {"x": [0.59], "y": [0]},
                        "t": 50,
                        "s": [0]
                    }, {
                        "i": {"x": [0.667], "y": [1]},
                        "o": {"x": [0.373], "y": [0]},
                        "t": 55,
                        "s": [100]
                    }, {
                        "i": {"x": [0.367], "y": [1]},
                        "o": {"x": [0.645], "y": [0]},
                        "t": 69,
                        "s": [100]
                    }, {
                        "i": {"x": [0.833], "y": [1]},
                        "o": {"x": [0.333], "y": [0]},
                        "t": 84,
                        "s": [0]
                    }, {"t": 89.0000036250443, "s": [0]}],
                    "ix": 11
                },
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {
                    "a": 1,
                    "k": [{
                        "i": {"x": 0.633, "y": 0.633},
                        "o": {"x": 0.645, "y": 0.645},
                        "t": 0,
                        "s": [960, 960, 0],
                        "to": [0, 0, 0],
                        "ti": [0, 0, 0]
                    }, {
                        "i": {"x": 0.367, "y": 1},
                        "o": {"x": 0.645, "y": 0},
                        "t": 69,
                        "s": [960, 960, 0],
                        "to": [0, -13, 0],
                        "ti": [0, 13, 0]
                    }, {
                        "i": {"x": 0.367, "y": 0.367},
                        "o": {"x": 0.333, "y": 0.333},
                        "t": 84,
                        "s": [960, 882, 0],
                        "to": [0, 0, 0],
                        "ti": [0, 0, 0]
                    }, {"t": 89.0000036250443, "s": [960, 882, 0]}],
                    "ix": 2,
                    "l": 2
                },
                "a": {"a": 0, "k": [100.5, 100.5, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [868.159, 868.159, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[-1.32, 0], [0, 0], [0, -1.32], [0, 0], [1.32, 0], [0, 0], [0, 1.32], [0, 0]],
                            "o": [[0, 0], [1.32, 0], [0, 0], [0, 1.32], [0, 0], [-1.32, 0], [0, 0], [0, -1.32]],
                            "v": [[-12.325, -6.276], [12.324, -6.276], [14.725, -3.876], [14.725, 3.876], [12.324, 6.276], [-12.325, 6.276], [-14.725, 3.876], [-14.725, -3.876]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.74900004069, 0.854899986117, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [100.4, 132.062], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 1",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }],
            "ip": 0,
            "op": 90.0000036657751,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 4,
            "ty": 4,
            "nm": "card-009",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [{
                        "i": {"x": [0.833], "y": [1]},
                        "o": {"x": [0.167], "y": [0]},
                        "t": 0,
                        "s": [0]
                    }, {
                        "i": {"x": [0.393], "y": [1]},
                        "o": {"x": [0.561], "y": [0]},
                        "t": 54,
                        "s": [0]
                    }, {
                        "i": {"x": [0.833], "y": [1]},
                        "o": {"x": [0.417], "y": [0]},
                        "t": 59,
                        "s": [100]
                    }, {
                        "i": {"x": [0.367], "y": [1]},
                        "o": {"x": [0.645], "y": [0]},
                        "t": 64,
                        "s": [100]
                    }, {
                        "i": {"x": [0.833], "y": [1]},
                        "o": {"x": [0.167], "y": [0]},
                        "t": 79,
                        "s": [0]
                    }, {"t": 89.0000036250443, "s": [0]}],
                    "ix": 11
                },
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {
                    "a": 1,
                    "k": [{
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.645, "y": 0.645},
                        "t": 0,
                        "s": [960, 960, 0],
                        "to": [0, 0, 0],
                        "ti": [0, 0, 0]
                    }, {
                        "i": {"x": 0.367, "y": 1},
                        "o": {"x": 0.645, "y": 0},
                        "t": 64,
                        "s": [960, 960, 0],
                        "to": [0, -13, 0],
                        "ti": [0, 13, 0]
                    }, {
                        "i": {"x": 0.367, "y": 0.367},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 79,
                        "s": [960, 882, 0],
                        "to": [0, 0, 0],
                        "ti": [0, 0, 0]
                    }, {"t": 89.0000036250443, "s": [960, 882, 0]}],
                    "ix": 2,
                    "l": 2
                },
                "a": {"a": 0, "k": [100.5, 100.5, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [868.159, 868.159, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[-1.32, 0], [0, 0], [0, -1.32], [0, 0], [1.32, 0], [0, 0], [0, 1.32], [0, 0]],
                            "o": [[0, 0], [1.32, 0], [0, 0], [0, 1.32], [0, 0], [-1.32, 0], [0, 0], [0, -1.32]],
                            "v": [[-12.325, -6.276], [12.324, -6.276], [14.725, -3.876], [14.725, 3.876], [12.324, 6.276], [-12.325, 6.276], [-14.725, 3.876], [-14.725, -3.876]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.74900004069, 0.854899986117, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [100.4, 116.237], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 1",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }],
            "ip": 0,
            "op": 90.0000036657751,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 5,
            "ty": 4,
            "nm": "paper-007",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [{
                        "i": {"x": [0.833], "y": [1]},
                        "o": {"x": [0.167], "y": [0]},
                        "t": 0,
                        "s": [100]
                    }, {
                        "i": {"x": [0.308], "y": [1]},
                        "o": {"x": [0.691], "y": [0]},
                        "t": 6,
                        "s": [100]
                    }, {
                        "i": {"x": [0.833], "y": [1]},
                        "o": {"x": [0.354], "y": [0]},
                        "t": 21,
                        "s": [100]
                    }, {
                        "i": {"x": [0.393], "y": [1]},
                        "o": {"x": [0.76], "y": [0]},
                        "t": 49,
                        "s": [100]
                    }, {
                        "i": {"x": [0.833], "y": [1]},
                        "o": {"x": [0.167], "y": [0]},
                        "t": 51,
                        "s": [0]
                    }, {"t": 89.0000036250443, "s": [0]}],
                    "ix": 11
                },
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {
                    "a": 1,
                    "k": [{
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.548, "y": 0.548},
                        "t": 0,
                        "s": [803, 251, 0],
                        "to": [0, 0, 0],
                        "ti": [0, 0, 0]
                    }, {
                        "i": {"x": 0.833, "y": 1},
                        "o": {"x": 0.548, "y": 0},
                        "t": 6,
                        "s": [803, 251, 0],
                        "to": [-389.5, 6.167, 0],
                        "ti": [69.5, -382.167, 0]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.512, "y": 0.512},
                        "t": 21,
                        "s": [-46, 960, 0],
                        "to": [0, 0, 0],
                        "ti": [0, 0, 0]
                    }, {
                        "i": {"x": 0.588, "y": 1},
                        "o": {"x": 0.512, "y": 0},
                        "t": 36,
                        "s": [-46, 960, 0],
                        "to": [90, 63.167, 0],
                        "ti": [-90, -63.167, 0]
                    }, {
                        "i": {"x": 0.588, "y": 0.588},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 49,
                        "s": [494, 1339, 0],
                        "to": [0, 0, 0],
                        "ti": [0, 0, 0]
                    }, {"t": 89.0000036250443, "s": [494, 1339, 0]}],
                    "ix": 2,
                    "l": 2
                },
                "a": {"a": 0, "k": [100.5, 100.5, 0], "ix": 1, "l": 2},
                "s": {
                    "a": 1,
                    "k": [{
                        "i": {"x": [0.833, 0.833, 0.833], "y": [1, 1, 1]},
                        "o": {"x": [0.167, 0.167, 0.167], "y": [0, 0, 0]},
                        "t": 0,
                        "s": [255.159, 255.159, 100]
                    }, {
                        "i": {"x": [0.423, 0.423, 0.833], "y": [1, 1, 1]},
                        "o": {"x": [0.447, 0.447, 0.167], "y": [0, 0, 0]},
                        "t": 6,
                        "s": [255.159, 255.159, 100]
                    }, {
                        "i": {"x": [0.833, 0.833, 0.833], "y": [1, 1, 1]},
                        "o": {"x": [0.536, 0.635, 0.333], "y": [0, 0, 0]},
                        "t": 21,
                        "s": [868.159, 868.159, 100]
                    }, {
                        "i": {"x": [0.588, 0.474, 0.667], "y": [1, 1, 1]},
                        "o": {"x": [0.512, 0.611, 0.333], "y": [0, 0, 0]},
                        "t": 36,
                        "s": [868.159, 868.159, 100]
                    }, {
                        "i": {"x": [0.833, 0.833, 0.833], "y": [1, 1, 1]},
                        "o": {"x": [0.167, 0.167, 0.167], "y": [0, 0, 0]},
                        "t": 49,
                        "s": [800.159, 214.159, 100]
                    }, {"t": 89.0000036250443, "s": [800.159, 214.159, 100]}],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[-0.693, 0], [0, 0], [0, -0.693], [0, 0], [0.693, 0], [0, 0], [0, 0.693], [0, 0]],
                            "o": [[0, 0], [0.693, 0], [0, 0], [0, 0.693], [0, 0], [-0.693, 0], [0, 0], [0, -0.693]],
                            "v": [[-4.304, -2.7], [4.304, -2.7], [5.563, -1.441], [5.563, 1.441], [4.304, 2.7], [-4.304, 2.7], [-5.563, 1.441], [-5.563, -1.441]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.74900004069, 0.854899986117, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [156.978, 129.314], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 1",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }, {
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[-0.693, 0], [0, 0], [0, -0.693], [0, 0], [0.693, 0], [0, 0], [0, 0.693], [0, 0]],
                            "o": [[0, 0], [0.693, 0], [0, 0], [0, 0.693], [0, 0], [-0.693, 0], [0, 0], [0, -0.693]],
                            "v": [[-5.883, -2.7], [5.883, -2.7], [7.142, -1.441], [7.142, 1.441], [5.883, 2.7], [-5.883, 2.7], [-7.142, 1.441], [-7.142, -1.441]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.74900004069, 0.854899986117, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [158.558, 120.789], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 2",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 2,
                "mn": "ADBE Vector Group",
                "hd": false
            }, {
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[-0.693, 0], [0, 0], [0, -0.693], [0, 0], [0.693, 0], [0, 0], [0, 0.693], [0, 0]],
                            "o": [[0, 0], [0.693, 0], [0, 0], [0, 0.693], [0, 0], [-0.693, 0], [0, 0], [0, -0.693]],
                            "v": [[-4.853, -2.7], [4.853, -2.7], [6.112, -1.441], [6.112, 1.441], [4.853, 2.7], [-4.853, 2.7], [-6.112, 1.441], [-6.112, -1.441]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.74900004069, 0.854899986117, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [157.528, 112.264], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 3",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 3,
                "mn": "ADBE Vector Group",
                "hd": false
            }, {
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[-0.693, 0], [0, 0], [0, -0.693], [0, 0], [0.693, 0], [0, 0], [0, 0.693], [0, 0]],
                            "o": [[0, 0], [0.693, 0], [0, 0], [0, 0.693], [0, 0], [-0.693, 0], [0, 0], [0, -0.693]],
                            "v": [[-7.393, -2.7], [7.393, -2.7], [8.653, -1.44], [8.653, 1.44], [7.393, 2.7], [-7.393, 2.7], [-8.653, 1.44], [-8.653, -1.44]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.74900004069, 0.854899986117, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [160.069, 103.739], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 4",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 4,
                "mn": "ADBE Vector Group",
                "hd": false
            }, {
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[-1.025, -22.274], [1.025, -22.274], [1.025, 22.274], [-1.025, 22.274]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0, 0.588199989468, 0.533300003351, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [145.61, 116.526], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 5",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 5,
                "mn": "ADBE Vector Group",
                "hd": false
            }, {
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [0, -1.32], [0, 0], [1.32, 0], [0, 0]],
                            "o": [[0, 0], [1.32, 0], [0, 0], [0, 1.32], [0, 0], [0, 0]],
                            "v": [[-13.434, -22.274], [11.034, -22.274], [13.434, -19.874], [13.434, 19.874], [11.034, 22.274], [-13.434, 22.274]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.870599963618, 0.925499949736, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [160.069, 116.526], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 6",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 6,
                "mn": "ADBE Vector Group",
                "hd": false
            }],
            "ip": 0,
            "op": 90.0000036657751,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 6,
            "ty": 4,
            "nm": "paper-008",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [{
                        "i": {"x": [0.833], "y": [1]},
                        "o": {"x": [0.167], "y": [0]},
                        "t": 0,
                        "s": [100]
                    }, {
                        "i": {"x": [0.308], "y": [1]},
                        "o": {"x": [0.691], "y": [0]},
                        "t": 10,
                        "s": [100]
                    }, {
                        "i": {"x": [0.833], "y": [1]},
                        "o": {"x": [0.354], "y": [0]},
                        "t": 25,
                        "s": [100]
                    }, {
                        "i": {"x": [0.393], "y": [1]},
                        "o": {"x": [0.76], "y": [0]},
                        "t": 53,
                        "s": [100]
                    }, {
                        "i": {"x": [0.833], "y": [1]},
                        "o": {"x": [0.167], "y": [0]},
                        "t": 55,
                        "s": [0]
                    }, {"t": 89.0000036250443, "s": [0]}],
                    "ix": 11
                },
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {
                    "a": 1,
                    "k": [{
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.548, "y": 0.548},
                        "t": 0,
                        "s": [1092, 96, 0],
                        "to": [0, 0, 0],
                        "ti": [0, 0, 0]
                    }, {
                        "i": {"x": 0.429, "y": 1},
                        "o": {"x": 0.548, "y": 0},
                        "t": 10,
                        "s": [1092, 96, 0],
                        "to": [596.833, 159, 0],
                        "ti": [0, 0, 0]
                    }, {
                        "i": {"x": 0.429, "y": 0.429},
                        "o": {"x": 0.353, "y": 0.353},
                        "t": 25,
                        "s": [1889, 882, 0],
                        "to": [0, 0, 0],
                        "ti": [0, 0, 0]
                    }, {
                        "i": {"x": 0.588, "y": 1},
                        "o": {"x": 0.353, "y": 0},
                        "t": 40,
                        "s": [1889, 882, 0],
                        "to": [0, 0, 0],
                        "ti": [48, -16.5, 0]
                    }, {
                        "i": {"x": 0.588, "y": 0.588},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 53,
                        "s": [1601, 981, 0],
                        "to": [0, 0, 0],
                        "ti": [0, 0, 0]
                    }, {"t": 89.0000036250443, "s": [1601, 981, 0]}],
                    "ix": 2,
                    "l": 2
                },
                "a": {"a": 0, "k": [100.5, 100.5, 0], "ix": 1, "l": 2},
                "s": {
                    "a": 1,
                    "k": [{
                        "i": {"x": [0.833, 0.833, 0.833], "y": [1, 1, 1]},
                        "o": {"x": [0.167, 0.167, 0.167], "y": [0, 0, 0]},
                        "t": 0,
                        "s": [255.159, 255.159, 100]
                    }, {
                        "i": {"x": [0.423, 0.423, 0.833], "y": [1, 1, 1]},
                        "o": {"x": [0.447, 0.447, 0.167], "y": [0, 0, 0]},
                        "t": 10,
                        "s": [255.159, 255.159, 100]
                    }, {
                        "i": {"x": [0.833, 0.833, 0.833], "y": [1, 1, 1]},
                        "o": {"x": [0.536, 0.635, 0.333], "y": [0, 0, 0]},
                        "t": 25,
                        "s": [868.159, 868.159, 100]
                    }, {
                        "i": {"x": [0.588, 0.474, 0.667], "y": [1, 1, 1]},
                        "o": {"x": [0.512, 0.611, 0.333], "y": [0, 0, 0]},
                        "t": 40,
                        "s": [868.159, 868.159, 100]
                    }, {
                        "i": {"x": [0.833, 0.833, 0.833], "y": [1, 1, 1]},
                        "o": {"x": [0.167, 0.167, 0.167], "y": [0, 0, 0]},
                        "t": 53,
                        "s": [1179.629, 299.524, 100]
                    }, {"t": 89.0000036250443, "s": [1179.629, 299.524, 100]}],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[-1.32, 0], [0, 0], [0, -1.32], [0, 0], [1.32, 0], [0, 0], [0, 1.32], [0, 0]],
                            "o": [[0, 0], [1.32, 0], [0, 0], [0, 1.32], [0, 0], [-1.32, 0], [0, 0], [0, -1.32]],
                            "v": [[-7.688, -15.54], [7.688, -15.54], [10.087, -13.14], [10.087, 13.14], [7.688, 15.54], [-7.688, 15.54], [-10.087, 13.14], [-10.087, -13.14]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.870599963618, 0.925499949736, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [46.127, 185.411], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 1",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }],
            "ip": 0,
            "op": 90.0000036657751,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 7,
            "ty": 4,
            "nm": "paper-009",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [{
                        "i": {"x": [0.833], "y": [1]},
                        "o": {"x": [0.167], "y": [0]},
                        "t": 0,
                        "s": [100]
                    }, {
                        "i": {"x": [0.308], "y": [1]},
                        "o": {"x": [0.691], "y": [0]},
                        "t": 14,
                        "s": [100]
                    }, {
                        "i": {"x": [0.667], "y": [1]},
                        "o": {"x": [0.354], "y": [0]},
                        "t": 29,
                        "s": [100]
                    }, {
                        "i": {"x": [0.393], "y": [1]},
                        "o": {"x": [0.76], "y": [0]},
                        "t": 57,
                        "s": [100]
                    }, {
                        "i": {"x": [0.833], "y": [1]},
                        "o": {"x": [0.333], "y": [0]},
                        "t": 59,
                        "s": [0]
                    }, {"t": 89.0000036250443, "s": [0]}],
                    "ix": 11
                },
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {
                    "a": 1,
                    "k": [{
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.548, "y": 0.548},
                        "t": 0,
                        "s": [1092, 328, 0],
                        "to": [0, 0, 0],
                        "ti": [0, 0, 0]
                    }, {
                        "i": {"x": 0.423, "y": 1},
                        "o": {"x": 0.548, "y": 0},
                        "t": 14,
                        "s": [1092, 328, 0],
                        "to": [147.333, 105.333, 0],
                        "ti": [-147.333, -105.333, 0]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.536, "y": 0.536},
                        "t": 29,
                        "s": [1976, 960, 0],
                        "to": [0, 0, 0],
                        "ti": [0, 0, 0]
                    }, {
                        "i": {"x": 0.588, "y": 1},
                        "o": {"x": 0.512, "y": 0},
                        "t": 44,
                        "s": [1976, 960, 0],
                        "to": [-84.667, 25.333, 0],
                        "ti": [84.667, -25.333, 0]
                    }, {
                        "i": {"x": 0.588, "y": 0.588},
                        "o": {"x": 0.333, "y": 0.333},
                        "t": 57,
                        "s": [1468, 1112, 0],
                        "to": [0, 0, 0],
                        "ti": [0, 0, 0]
                    }, {"t": 89.0000036250443, "s": [1468, 1112, 0]}],
                    "ix": 2,
                    "l": 2
                },
                "a": {"a": 0, "k": [100.5, 100.5, 0], "ix": 1, "l": 2},
                "s": {
                    "a": 1,
                    "k": [{
                        "i": {"x": [0.833, 0.833, 0.833], "y": [1, 1, 1]},
                        "o": {"x": [0.167, 0.167, 0.167], "y": [0, 0, 0]},
                        "t": 0,
                        "s": [255.159, 255.159, 100]
                    }, {
                        "i": {"x": [0.423, 0.423, 0.833], "y": [1, 1, 1]},
                        "o": {"x": [0.447, 0.447, 0.167], "y": [0, 0, 0]},
                        "t": 14,
                        "s": [255.159, 255.159, 100]
                    }, {
                        "i": {"x": [0.833, 0.833, 0.833], "y": [1, 1, 1]},
                        "o": {"x": [0.536, 0.635, 0.333], "y": [0, 0, 0]},
                        "t": 29,
                        "s": [868.159, 868.159, 100]
                    }, {
                        "i": {"x": [0.588, 0.474, 0.667], "y": [1, 1, 1]},
                        "o": {"x": [0.512, 0.611, 0.333], "y": [0, 0, 0]},
                        "t": 44,
                        "s": [868.159, 868.159, 100]
                    }, {
                        "i": {"x": [0.833, 0.833, 0.833], "y": [1, 1, 1]},
                        "o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]},
                        "t": 57,
                        "s": [868.159, 196.159, 100]
                    }, {"t": 89.0000036250443, "s": [868.159, 196.159, 100]}],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[-1.631, 0], [0, -1.631], [1.631, 0], [0, 1.631]],
                            "o": [[1.631, 0], [0, 1.631], [-1.631, 0], [0, -1.631]],
                            "v": [[0, -2.953], [2.953, 0], [0, 2.953], [-2.953, 0]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [1, 0.756900024414, 0.027499999252, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [34.001, 107.846], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 1",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }, {
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[-1.631, 0], [0, -1.631], [1.631, 0], [0, 1.631]],
                            "o": [[1.631, 0], [0, 1.631], [-1.631, 0], [0, -1.631]],
                            "v": [[0, -2.953], [2.953, 0], [0, 2.953], [-2.953, 0]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.956900024414, 0.262699979894, 0.211799995572, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [34.001, 98.783], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 2",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 2,
                "mn": "ADBE Vector Group",
                "hd": false
            }, {
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[-1.631, 0], [0, -1.631], [1.631, 0], [0, 1.631]],
                            "o": [[1.631, 0], [0, 1.631], [-1.631, 0], [0, -1.631]],
                            "v": [[0, -2.953], [2.953, 0], [0, 2.953], [-2.953, 0]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0, 0.588199989468, 0.533300003351, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [34.001, 89.721], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 3",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 3,
                "mn": "ADBE Vector Group",
                "hd": false
            }, {
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[-1.631, 0], [0, -1.631], [1.631, 0], [0, 1.631]],
                            "o": [[1.631, 0], [0, 1.631], [-1.631, 0], [0, -1.631]],
                            "v": [[0, -2.953], [2.953, 0], [0, 2.953], [-2.953, 0]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0, 0.588199989468, 0.533300003351, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [34.001, 80.658], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 4",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 4,
                "mn": "ADBE Vector Group",
                "hd": false
            }, {
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[-1.32, 0], [0, 0], [0, -1.32], [0, 0], [1.32, 0], [0, 0], [0, 1.32], [0, 0]],
                            "o": [[0, 0], [1.32, 0], [0, 0], [0, 1.32], [0, 0], [-1.32, 0], [0, 0], [0, -1.32]],
                            "v": [[-12.059, -22.274], [12.059, -22.274], [14.459, -19.874], [14.459, 19.874], [12.059, 22.274], [-12.059, 22.274], [-14.459, 19.874], [-14.459, -19.874]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.870599963618, 0.925499949736, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [41.756, 94.252], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 5",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 5,
                "mn": "ADBE Vector Group",
                "hd": false
            }],
            "ip": 0,
            "op": 90.0000036657751,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 8,
            "ty": 4,
            "nm": "card-006",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [{
                        "i": {"x": [0.355], "y": [1]},
                        "o": {"x": [0.633], "y": [0]},
                        "t": 0,
                        "s": [0]
                    }, {
                        "i": {"x": [0.583], "y": [1]},
                        "o": {"x": [0.167], "y": [0]},
                        "t": 15,
                        "s": [100]
                    }, {
                        "i": {"x": [0.439], "y": [1]},
                        "o": {"x": [0.607], "y": [0]},
                        "t": 30,
                        "s": [100]
                    }, {"t": 35.0000014255792, "s": [0]}],
                    "ix": 11
                },
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {
                    "a": 1,
                    "k": [{
                        "i": {"x": 0.355, "y": 1},
                        "o": {"x": 0.633, "y": 0},
                        "t": 0,
                        "s": [960, 1038, 0],
                        "to": [0, -13, 0],
                        "ti": [0, 13, 0]
                    }, {"t": 15.0000006109625, "s": [960, 960, 0]}],
                    "ix": 2,
                    "l": 2
                },
                "a": {"a": 0, "k": [100.5, 100.5, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [868.159, 868.159, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[-1.32, 0], [0, 0], [0, -1.32], [0, 0], [1.32, 0], [0, 0], [0, 1.32], [0, 0]],
                            "o": [[0, 0], [1.32, 0], [0, 0], [0, 1.32], [0, 0], [-1.32, 0], [0, 0], [0, -1.32]],
                            "v": [[-12.325, -6.276], [12.324, -6.276], [14.725, -3.876], [14.725, 3.876], [12.324, 6.276], [-12.325, 6.276], [-14.725, 3.876], [-14.725, -3.876]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.74900004069, 0.854899986117, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [100.4, 116.237], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 1",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }],
            "ip": 0,
            "op": 90.0000036657751,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 9,
            "ty": 4,
            "nm": "card-005",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [{
                        "i": {"x": [0.355], "y": [1]},
                        "o": {"x": [0.633], "y": [0]},
                        "t": 5,
                        "s": [0]
                    }, {
                        "i": {"x": [0.627], "y": [1]},
                        "o": {"x": [0.333], "y": [0]},
                        "t": 20,
                        "s": [100]
                    }, {
                        "i": {"x": [0.41], "y": [1]},
                        "o": {"x": [0.607], "y": [0]},
                        "t": 34,
                        "s": [100]
                    }, {"t": 39.0000015885026, "s": [0]}],
                    "ix": 11
                },
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {
                    "a": 1,
                    "k": [{
                        "i": {"x": 0.355, "y": 1},
                        "o": {"x": 0.633, "y": 0},
                        "t": 5,
                        "s": [960, 1038, 0],
                        "to": [0, -13, 0],
                        "ti": [0, 13, 0]
                    }, {"t": 20.0000008146167, "s": [960, 960, 0]}],
                    "ix": 2,
                    "l": 2
                },
                "a": {"a": 0, "k": [100.5, 100.5, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [868.159, 868.159, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[-1.32, 0], [0, 0], [0, -1.32], [0, 0], [1.32, 0], [0, 0], [0, 1.32], [0, 0]],
                            "o": [[0, 0], [1.32, 0], [0, 0], [0, 1.32], [0, 0], [-1.32, 0], [0, 0], [0, -1.32]],
                            "v": [[-12.325, -6.276], [12.324, -6.276], [14.725, -3.876], [14.725, 3.876], [12.324, 6.276], [-12.325, 6.276], [-14.725, 3.876], [-14.725, -3.876]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.74900004069, 0.854899986117, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [100.4, 132.062], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 1",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }],
            "ip": 0,
            "op": 90.0000036657751,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 10,
            "ty": 4,
            "nm": "card-004",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [{
                        "i": {"x": [0.355], "y": [1]},
                        "o": {"x": [0.633], "y": [0]},
                        "t": 10,
                        "s": [0]
                    }, {
                        "i": {"x": [0.672], "y": [1]},
                        "o": {"x": [0.167], "y": [0]},
                        "t": 25,
                        "s": [100]
                    }, {
                        "i": {"x": [0.496], "y": [1]},
                        "o": {"x": [0.607], "y": [0]},
                        "t": 38,
                        "s": [100]
                    }, {"t": 43.0000017514259, "s": [0]}],
                    "ix": 11
                },
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {
                    "a": 1,
                    "k": [{
                        "i": {"x": 0.355, "y": 1},
                        "o": {"x": 0.633, "y": 0},
                        "t": 10,
                        "s": [960, 1038, 0],
                        "to": [0, -13, 0],
                        "ti": [0, 13, 0]
                    }, {
                        "i": {"x": 0.833, "y": 0.833},
                        "o": {"x": 0.367, "y": 0.367},
                        "t": 25,
                        "s": [960, 960, 0],
                        "to": [0, 0, 0],
                        "ti": [0, 0, 0]
                    }, {"t": 149.000006068894, "s": [960, 960, 0]}],
                    "ix": 2,
                    "l": 2
                },
                "a": {"a": 0, "k": [100.5, 100.5, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [868.159, 868.159, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[-1.32, 0], [0, 0], [0, -1.32], [0, 0], [1.32, 0], [0, 0], [0, 1.32], [0, 0]],
                            "o": [[0, 0], [1.32, 0], [0, 0], [0, 1.32], [0, 0], [-1.32, 0], [0, 0], [0, -1.32]],
                            "v": [[-12.325, -6.276], [12.324, -6.276], [14.725, -3.876], [14.725, 3.876], [12.324, 6.276], [-12.325, 6.276], [-14.725, 3.876], [-14.725, -3.876]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.74900004069, 0.854899986117, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [100.4, 147.886], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 1",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }],
            "ip": 0,
            "op": 90.0000036657751,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 11,
            "ty": 4,
            "nm": "paper-006",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [{
                        "i": {"x": [0.24], "y": [1]},
                        "o": {"x": [0.607], "y": [0]},
                        "t": 30,
                        "s": [0]
                    }, {
                        "i": {"x": [0.646], "y": [1]},
                        "o": {"x": [0.333], "y": [0]},
                        "t": 32,
                        "s": [100]
                    }, {
                        "i": {"x": [0.309], "y": [1]},
                        "o": {"x": [0.692], "y": [0]},
                        "t": 60,
                        "s": [100]
                    }, {"t": 75.0000030548126, "s": [100]}],
                    "ix": 11
                },
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {
                    "a": 1,
                    "k": [{
                        "i": {"x": 0.488, "y": 1},
                        "o": {"x": 0.412, "y": 0},
                        "t": 32,
                        "s": [1468, 1112, 0],
                        "to": [-84.667, -25.333, 0],
                        "ti": [84.667, 25.333, 0]
                    }, {
                        "i": {"x": 0.464, "y": 0.464},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 45,
                        "s": [960, 960, 0],
                        "to": [0, 0, 0],
                        "ti": [0, 0, 0]
                    }, {
                        "i": {"x": 0.452, "y": 1},
                        "o": {"x": 0.577, "y": 0},
                        "t": 60,
                        "s": [960, 960, 0],
                        "to": [22, -105.333, 0],
                        "ti": [-22, 105.333, 0]
                    }, {"t": 75.0000030548126, "s": [1092, 328, 0]}],
                    "ix": 2,
                    "l": 2
                },
                "a": {"a": 0, "k": [100.5, 100.5, 0], "ix": 1, "l": 2},
                "s": {
                    "a": 1,
                    "k": [{
                        "i": {"x": [0.488, 0.389, 0.667], "y": [1, 1, 1]},
                        "o": {"x": [0.412, 0.526, 0.333], "y": [0, 0, 0]},
                        "t": 32,
                        "s": [868.159, 196.159, 100]
                    }, {
                        "i": {"x": [0.464, 0.365, 0.667], "y": [1, 1, 1]},
                        "o": {"x": [0.167, 0.167, 0.167], "y": [0, 0, 0]},
                        "t": 45,
                        "s": [868.159, 868.159, 100]
                    }, {
                        "i": {"x": [0.553, 0.553, 0.833], "y": [1, 1, 1]},
                        "o": {"x": [0.577, 0.577, 0.167], "y": [0, 0, 0]},
                        "t": 60,
                        "s": [868.159, 868.159, 100]
                    }, {"t": 75.0000030548126, "s": [255.159, 255.159, 100]}],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[-1.631, 0], [0, -1.631], [1.631, 0], [0, 1.631]],
                            "o": [[1.631, 0], [0, 1.631], [-1.631, 0], [0, -1.631]],
                            "v": [[0, -2.953], [2.953, 0], [0, 2.953], [-2.953, 0]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [1, 0.756900024414, 0.027499999252, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [34.001, 107.846], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 1",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }, {
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[-1.631, 0], [0, -1.631], [1.631, 0], [0, 1.631]],
                            "o": [[1.631, 0], [0, 1.631], [-1.631, 0], [0, -1.631]],
                            "v": [[0, -2.953], [2.953, 0], [0, 2.953], [-2.953, 0]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.956900024414, 0.262699979894, 0.211799995572, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [34.001, 98.783], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 2",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 2,
                "mn": "ADBE Vector Group",
                "hd": false
            }, {
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[-1.631, 0], [0, -1.631], [1.631, 0], [0, 1.631]],
                            "o": [[1.631, 0], [0, 1.631], [-1.631, 0], [0, -1.631]],
                            "v": [[0, -2.953], [2.953, 0], [0, 2.953], [-2.953, 0]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0, 0.588199989468, 0.533300003351, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [34.001, 89.721], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 3",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 3,
                "mn": "ADBE Vector Group",
                "hd": false
            }, {
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[-1.631, 0], [0, -1.631], [1.631, 0], [0, 1.631]],
                            "o": [[1.631, 0], [0, 1.631], [-1.631, 0], [0, -1.631]],
                            "v": [[0, -2.953], [2.953, 0], [0, 2.953], [-2.953, 0]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0, 0.588199989468, 0.533300003351, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [34.001, 80.658], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 4",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 4,
                "mn": "ADBE Vector Group",
                "hd": false
            }, {
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[-1.32, 0], [0, 0], [0, -1.32], [0, 0], [1.32, 0], [0, 0], [0, 1.32], [0, 0]],
                            "o": [[0, 0], [1.32, 0], [0, 0], [0, 1.32], [0, 0], [-1.32, 0], [0, 0], [0, -1.32]],
                            "v": [[-12.059, -22.274], [12.059, -22.274], [14.459, -19.874], [14.459, 19.874], [12.059, 22.274], [-12.059, 22.274], [-14.459, 19.874], [-14.459, -19.874]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.870599963618, 0.925499949736, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [41.756, 94.252], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 5",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 5,
                "mn": "ADBE Vector Group",
                "hd": false
            }],
            "ip": 0,
            "op": 90.0000036657751,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 12,
            "ty": 4,
            "nm": "paper-005",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [{
                        "i": {"x": [0.24], "y": [1]},
                        "o": {"x": [0.607], "y": [0]},
                        "t": 34,
                        "s": [0]
                    }, {
                        "i": {"x": [0.646], "y": [1]},
                        "o": {"x": [0.167], "y": [0]},
                        "t": 36,
                        "s": [100]
                    }, {
                        "i": {"x": [0.309], "y": [1]},
                        "o": {"x": [0.692], "y": [0]},
                        "t": 64,
                        "s": [100]
                    }, {"t": 79.000003217736, "s": [100]}],
                    "ix": 11
                },
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {
                    "a": 1,
                    "k": [{
                        "i": {"x": 0.488, "y": 1},
                        "o": {"x": 0.412, "y": 0},
                        "t": 36,
                        "s": [1601, 981, 0],
                        "to": [-106.833, -3.5, 0],
                        "ti": [106.833, 3.5, 0]
                    }, {
                        "i": {"x": 0.464, "y": 0.464},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 49,
                        "s": [960, 960, 0],
                        "to": [0, 0, 0],
                        "ti": [0, 0, 0]
                    }, {
                        "i": {"x": 0.452, "y": 1},
                        "o": {"x": 0.577, "y": 0},
                        "t": 64,
                        "s": [960, 960, 0],
                        "to": [-112, -198, 0],
                        "ti": [-176, 162, 0]
                    }, {"t": 79.000003217736, "s": [1092, 96, 0]}],
                    "ix": 2,
                    "l": 2
                },
                "a": {"a": 0, "k": [100.5, 100.5, 0], "ix": 1, "l": 2},
                "s": {
                    "a": 1,
                    "k": [{
                        "i": {"x": [0.488, 0.389, 0.667], "y": [1, 1, 1]},
                        "o": {"x": [0.412, 0.526, 0.333], "y": [0, 0, 0]},
                        "t": 36,
                        "s": [1179.629, 299.524, 100]
                    }, {
                        "i": {"x": [0.464, 0.365, 0.667], "y": [1, 1, 1]},
                        "o": {"x": [0.167, 0.167, 0.167], "y": [0, 0, 0]},
                        "t": 49,
                        "s": [868.159, 868.159, 100]
                    }, {
                        "i": {"x": [0.553, 0.553, 0.833], "y": [1, 1, 1]},
                        "o": {"x": [0.577, 0.577, 0.167], "y": [0, 0, 0]},
                        "t": 64,
                        "s": [868.159, 868.159, 100]
                    }, {"t": 79.000003217736, "s": [255.159, 255.159, 100]}],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[-1.32, 0], [0, 0], [0, -1.32], [0, 0], [1.32, 0], [0, 0], [0, 1.32], [0, 0]],
                            "o": [[0, 0], [1.32, 0], [0, 0], [0, 1.32], [0, 0], [-1.32, 0], [0, 0], [0, -1.32]],
                            "v": [[-7.688, -15.54], [7.688, -15.54], [10.087, -13.14], [10.087, 13.14], [7.688, 15.54], [-7.688, 15.54], [-10.087, 13.14], [-10.087, -13.14]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.870599963618, 0.925499949736, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [46.127, 185.411], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 1",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }],
            "ip": 0,
            "op": 90.0000036657751,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 13,
            "ty": 4,
            "nm": "paper-004",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [{
                        "i": {"x": [0.24], "y": [1]},
                        "o": {"x": [0.607], "y": [0]},
                        "t": 38,
                        "s": [0]
                    }, {
                        "i": {"x": [0.646], "y": [1]},
                        "o": {"x": [0.167], "y": [0]},
                        "t": 40,
                        "s": [100]
                    }, {
                        "i": {"x": [0.309], "y": [1]},
                        "o": {"x": [0.692], "y": [0]},
                        "t": 68,
                        "s": [100]
                    }, {"t": 83.0000033806593, "s": [100]}],
                    "ix": 11
                },
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {
                    "a": 1,
                    "k": [{
                        "i": {"x": 0.488, "y": 1},
                        "o": {"x": 0.412, "y": 0},
                        "t": 40,
                        "s": [494, 1339, 0],
                        "to": [77.667, -63.167, 0],
                        "ti": [-77.667, 63.167, 0]
                    }, {
                        "i": {"x": 0.464, "y": 0.464},
                        "o": {"x": 0.167, "y": 0.167},
                        "t": 53,
                        "s": [960, 960, 0],
                        "to": [0, 0, 0],
                        "ti": [0, 0, 0]
                    }, {
                        "i": {"x": 0.452, "y": 1},
                        "o": {"x": 0.577, "y": 0},
                        "t": 68,
                        "s": [960, 960, 0],
                        "to": [-26.167, -118.167, 0],
                        "ti": [26.167, 118.167, 0]
                    }, {"t": 83.0000033806593, "s": [803, 251, 0]}],
                    "ix": 2,
                    "l": 2
                },
                "a": {"a": 0, "k": [100.5, 100.5, 0], "ix": 1, "l": 2},
                "s": {
                    "a": 1,
                    "k": [{
                        "i": {"x": [0.488, 0.389, 0.667], "y": [1, 1, 1]},
                        "o": {"x": [0.412, 0.526, 0.333], "y": [0, 0, 0]},
                        "t": 40,
                        "s": [800.159, 214.159, 100]
                    }, {
                        "i": {"x": [0.464, 0.365, 0.667], "y": [1, 1, 1]},
                        "o": {"x": [0.167, 0.167, 0.167], "y": [0, 0, 0]},
                        "t": 53,
                        "s": [868.159, 868.159, 100]
                    }, {
                        "i": {"x": [0.553, 0.553, 0.833], "y": [1, 1, 1]},
                        "o": {"x": [0.577, 0.577, 0.167], "y": [0, 0, 0]},
                        "t": 68,
                        "s": [868.159, 868.159, 100]
                    }, {"t": 83.0000033806593, "s": [255.159, 255.159, 100]}],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[-0.693, 0], [0, 0], [0, -0.693], [0, 0], [0.693, 0], [0, 0], [0, 0.693], [0, 0]],
                            "o": [[0, 0], [0.693, 0], [0, 0], [0, 0.693], [0, 0], [-0.693, 0], [0, 0], [0, -0.693]],
                            "v": [[-4.304, -2.7], [4.304, -2.7], [5.563, -1.441], [5.563, 1.441], [4.304, 2.7], [-4.304, 2.7], [-5.563, 1.441], [-5.563, -1.441]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.74900004069, 0.854899986117, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [156.978, 129.314], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 1",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }, {
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[-0.693, 0], [0, 0], [0, -0.693], [0, 0], [0.693, 0], [0, 0], [0, 0.693], [0, 0]],
                            "o": [[0, 0], [0.693, 0], [0, 0], [0, 0.693], [0, 0], [-0.693, 0], [0, 0], [0, -0.693]],
                            "v": [[-5.883, -2.7], [5.883, -2.7], [7.142, -1.441], [7.142, 1.441], [5.883, 2.7], [-5.883, 2.7], [-7.142, 1.441], [-7.142, -1.441]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.74900004069, 0.854899986117, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [158.558, 120.789], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 2",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 2,
                "mn": "ADBE Vector Group",
                "hd": false
            }, {
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[-0.693, 0], [0, 0], [0, -0.693], [0, 0], [0.693, 0], [0, 0], [0, 0.693], [0, 0]],
                            "o": [[0, 0], [0.693, 0], [0, 0], [0, 0.693], [0, 0], [-0.693, 0], [0, 0], [0, -0.693]],
                            "v": [[-4.853, -2.7], [4.853, -2.7], [6.112, -1.441], [6.112, 1.441], [4.853, 2.7], [-4.853, 2.7], [-6.112, 1.441], [-6.112, -1.441]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.74900004069, 0.854899986117, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [157.528, 112.264], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 3",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 3,
                "mn": "ADBE Vector Group",
                "hd": false
            }, {
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[-0.693, 0], [0, 0], [0, -0.693], [0, 0], [0.693, 0], [0, 0], [0, 0.693], [0, 0]],
                            "o": [[0, 0], [0.693, 0], [0, 0], [0, 0.693], [0, 0], [-0.693, 0], [0, 0], [0, -0.693]],
                            "v": [[-7.393, -2.7], [7.393, -2.7], [8.653, -1.44], [8.653, 1.44], [7.393, 2.7], [-7.393, 2.7], [-8.653, 1.44], [-8.653, -1.44]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.74900004069, 0.854899986117, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [160.069, 103.739], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 4",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 4,
                "mn": "ADBE Vector Group",
                "hd": false
            }, {
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0], [0, 0], [0, 0]],
                            "v": [[-1.025, -22.274], [1.025, -22.274], [1.025, 22.274], [-1.025, 22.274]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0, 0.588199989468, 0.533300003351, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [145.61, 116.526], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 5",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 5,
                "mn": "ADBE Vector Group",
                "hd": false
            }, {
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [0, -1.32], [0, 0], [1.32, 0], [0, 0]],
                            "o": [[0, 0], [1.32, 0], [0, 0], [0, 1.32], [0, 0], [0, 0]],
                            "v": [[-13.434, -22.274], [11.034, -22.274], [13.434, -19.874], [13.434, 19.874], [11.034, 22.274], [-13.434, 22.274]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.870599963618, 0.925499949736, 1, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [160.069, 116.526], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 6",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 6,
                "mn": "ADBE Vector Group",
                "hd": false
            }],
            "ip": 0,
            "op": 90.0000036657751,
            "st": 0,
            "bm": 0
        }, {
            "ddd": 0,
            "ind": 14,
            "ty": 4,
            "nm": "phone",
            "sr": 1,
            "ks": {
                "o": {"a": 0, "k": 100, "ix": 11},
                "r": {"a": 0, "k": 0, "ix": 10},
                "p": {"a": 0, "k": [960, 960, 0], "ix": 2, "l": 2},
                "a": {"a": 0, "k": [100.5, 100.5, 0], "ix": 1, "l": 2},
                "s": {"a": 0, "k": [872.659, 872.659, 100], "ix": 6, "l": 2}
            },
            "ao": 0,
            "shapes": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[-3.709, 0], [0, 0], [0, -3.709], [0, 0], [0, 0], [0, 0], [0.89, 0], [0, 0], [0, -0.89], [0, 0], [0, 0], [0, 0]],
                            "o": [[0, 0], [3.709, 0], [0, 0], [0, 0], [0, 0], [0, -0.89], [0, 0], [-0.89, 0], [0, 0], [0, 0], [0, 0], [0, -3.709]],
                            "v": [[-13.877, -22.612], [13.877, -22.612], [20.62, -15.869], [20.62, 22.612], [19.169, 22.612], [19.169, -14.585], [17.551, -16.203], [-17.551, -16.203], [-19.169, -14.585], [-19.169, 22.612], [-20.62, 22.612], [-20.62, -15.869]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.066699996649, 0.341199987075, 0.725500009574, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [100.4, 116.864], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 1",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }, {
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0], [3.709, 0], [0, 0], [0, 3.709], [0, 0], [0, 0], [0, 0], [-0.89, 0], [0, 0], [0, 0.89], [0, 0]],
                            "o": [[0, 0], [0, 3.709], [0, 0], [-3.709, 0], [0, 0], [0, 0], [0, 0], [0, 0.89], [0, 0], [0.89, 0], [0, 0], [0, 0]],
                            "v": [[20.62, -25.547], [20.62, 18.804], [13.877, 25.547], [-13.877, 25.547], [-20.62, 18.804], [-20.62, -25.547], [-19.169, -25.547], [-19.169, 17.521], [-17.551, 19.139], [17.551, 19.139], [19.169, 17.521], [19.169, -25.547]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "fl",
                    "c": {"a": 0, "k": [0.066699996649, 0.341199987075, 0.725500009574, 1], "ix": 4},
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [100.4, 144.323], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 2",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 2,
                "mn": "ADBE Vector Group",
                "hd": false
            }],
            "ip": 0,
            "op": 90.0000036657751,
            "st": 0,
            "bm": 0
        }], "markers":
        []
}